import React from 'react';
import { View, Text, ScrollView, ActivityIndicator, Image, TextInput, CheckBox } from 'react-native';
import { Button, ButtonGroup } from 'react-native-elements';
import screen from '../screen';
import Icon from 'react-native-vector-icons/FontAwesome';
import Lib from '../Lib';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'modal-enhanced-react-native-web';
import log from 'loglevel';
import evmLib from '../evmLib';
import Analytic from './Analytic';
import DAO from './DAO';
import Panels from './Panels';
import { TouchableOpacity } from 'react-native-web';

const vp = screen.vp;
const vps = screen.vps;
const landscape = screen.landscape;
const spc = <View style={{ width: vps(2), height: vps(2) }} />;
const textColor1 = 'white';
const TOKEN = 'XYZ';
const USDT = 'USDT';
const ETH = 'CFX';

const TITLE = {};
TITLE['mint'] = 'JOIN CULT';
TITLE['claim'] = 'REWARD';
TITLE['buy'] = 'MINT XYZ';
TITLE['sell'] = 'BURN XYZ';
TITLE['stake'] = 'STAKING';
TITLE['burn'] = 'LEAVE CULT';

const textStyle1 = { textAlign: 'center', color: textColor1, textTransform: 'uppercase' };
const textStyle1b = { textAlign: 'center', color: textColor1, textTransform: 'uppercase', fontWeight: 'bold' };
const buttonStyle = { borderColor: 'white', borderWidth: 1 };
const titleStyle = { color: 'white' };

function to4dec(amount) {
  return (Math.round(Number(amount) * 10000) / 10000);
}

function to2dec(amount) {
  return (Math.round(Number(amount) * 100) / 100);
}

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disclaimerAgree: false,
      show: 'connecting',
      connected: false,
      connecting: false,
      nftData: {},
      selectedNFT: 0,
      treasuryData: {},
      buyerData: {},
      lpvaultData: {},
      contentIndex: 0
    };
  }

  async componentDidMount() {
    await this.connectMetamask();
  }

  componentWillUnmount() {
  }

  async connectMetamask() {
    this.setState({ showMetamaskError: false, connecting: true });

    const showDisclaimer = async () => {
      const val = await Lib.getStorageValue('DISCLAIMER_HIDE');
      if (val === 'yes')
        this.setState({ connected: true, show: 'content' });
      else if (val === 'no')
        this.setState({ connected: true, show: 'disclaimer', disclaimerAgree: true });
      else
        this.setState({ connected: true, show: 'disclaimer' });
    }

    try {
      const connected = await evmLib.detectMetamask();
      if (connected) {
        await evmLib.loadMetamask();
        await this.refreshData();
        this.setState({ connecting: false });
        await evmLib.adminData();
        return showDisclaimer();
      }
    } catch (err) {
      log.error(err.message);
      if (err.message && err.message === 'Please install Metamask and reload!') {
        this.setState({ showMetamaskError: 'not installed' });
      } else if (err.message && err.message === 'Please connect metamask to right network!') {
        this.setState({ showMetamaskError: 'wrong network' });
      }
    }

    // await Lib.clearStorageValue();
    this.setState({ connected: false, show: 'disconnect' });;
  }

  async refreshData() {
    try {
      const userData = await evmLib.userData();
      const nftData = await evmLib.nftData();
      let selectedNFT;
      if (nftData.userOwnedNFTIds && nftData.userOwnedNFTIds > 0) selectedNFT = nftData.userOwnedNFTIds[0];
      const treasuryData = await evmLib.treasuryData();
      const buyerData = await evmLib.buyerData();
      const lpvaultData = await evmLib.lpvaultData();
      return this.setState({ connected: true, userData, nftData, selectedNFT, treasuryData, buyerData, lpvaultData });
    } catch (err) {
      log.error(err.message);
    }
  }

  async buyUSDT(amountETH) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.routerBuyUsdt(amountETH);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async burnAllToken() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.tokenBurnAll();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async nftMint() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null, modalMintVisible: false });
    try {
      const txHash = await evmLib.nftMint();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async burnNFT(nftId) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    + 'hello';
    try {
      const txHash = await evmLib.nftBurn(nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async withdraw(index) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.nftWithdraw(index);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async approveUSDT() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.usdtApprove(evmLib.TREASURY_ADDRESS);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async approveToken() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.tokenApprove(evmLib.TREASURY_ADDRESS);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  setAmountByPctg(pctg, swapType) {
    const userData = this.state.userData;
    if (swapType === 'buy') {
      let numToken = Number(userData.userUSDT) * pctg / 100;
      if (pctg === 100) numToken = userData.userUSDT;
      this.setAmountInput(numToken + '', swapType);
    }
    if (swapType === 'sell') {
      let numToken = Number(userData.userToken) * pctg / 100;
      if (pctg === 100) numToken = userData.userToken;
      this.setAmountInput(numToken + '', swapType);
    }
  }

  async setAmountInput(amount, swapType) {
    this.setState({ amountInput: amount });
    if (swapType === 'buy') {
      let resultSwap = 0;
      let resultSwapFromDex = 0;
      if (Number(amount > 0)) {
        resultSwap = await evmLib.coinToToken(amount);
        resultSwapFromDex = await evmLib.coinToTokenFromDex(amount);
      }
      this.setState({ resultSwap, resultSwapFromDex });
    } else if (swapType === 'sell') {
      let resultSwap = 0;
      let resultSwapFromDex = 0;
      if (Number(amount > 0)) resultSwap = await evmLib.tokenToCoin(amount);
      this.setState({ resultSwap, resultSwapFromDex });
    }
  }

  async busyProcess() {
    try {
      await Lib.delay(5 * 60 * 1000);
      await this.refreshData();
    } catch (err) {

    }
    this.setState({ txError: 'timeout' });
  }

  async swapCoinToToken(amount, nftId) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });

    try {
      const result = await evmLib.runArbitrage(false, nftId);
      if (result.strategy !== 'stay out') return this.busyProcess();
    } catch (err) {
    }

    try {
      const txHash = await evmLib.swapCoinToToken(amount, nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async swapTokenToCoin(amount, nftId) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });

    try {
      const result = await evmLib.runArbitrage(false, nftId);
      if (result.strategy !== 'stay out') return this.busyProcess();
    } catch (err) {
    }

    try {
      const txHash = await evmLib.swapTokenToCoin(amount, nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async treasuryUpdate() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.treasuryUpdate();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async nftUpdate() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.nftUpdate();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async nftClaim(nftId) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.nftClaim(nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async nftWithdraw(index) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.nftWithdraw(index);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async ethTransfer() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.ethTransfer(evmLib.BUYER_ADDRESS, evmLib.eth2wei('1'));
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async buyerBuy() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.buyerBuy();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async buyerApproveUSDT() {
    try {
      const txHash = await evmLib.usdtApprove(evmLib.BUYER_ADDRESS);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async simulateArbitrage(nftId) {
    this.setState({ simulationResult: false })
    try {
      const result = await evmLib.runArbitrage(false, nftId);
      this.setState({ simulationResult: result })
    } catch (err) {
      log.error(err);
    }
  }

  async runArbitrage(nftId) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null, simulationResult: null });
    try {
      const txHash = await evmLib.runArbitrage(true, nftId);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async buyerUpdate() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.buyerUpdate();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async lpvaultApprove() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.lpvaultApprove();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async lpvaultStake(amount) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.lpvaultStake(amount);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async lpvaultUnstake(amount) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.lpvaultUnstake(amount);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async lpvaultClaim() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });

    try {
      const check = await evm.nftData();
      if (check.freezeTime) return this.busyProcess();
    } catch (err) {
    }

    try {
      const txHash = await evmLib.lpvaultClaim();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async lpvaultWithdraw() {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.lpvaultWithdraw();
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async bcvSetPricingScale(pctg) {
    this.setState({ modalTxVisible: true, txHash: null, txError: null });
    try {
      const txHash = await evmLib.bcvSetPricingScale(pctg);
      await this.refreshData();
      this.setState({ txHash: txHash });
    } catch (err) {
      log.error(err);
      const errMsg = err && err.message ? err.message : 'unknown error';
      this.setState({ txError: errMsg });
    }
  }

  async adminAction() {
    await this.buyUSDT('9000');
  }

  async test() {
  }

  renderDisclaimer() {
    const msg1 = 'The project is currently in its alpha testing phase and have limit of 100 NFT memberships to be minted. NFT owners are incentivized with a 20% staking reward from the circulating supply annually, as well as a daily claim of 10% from the circulating supply annually.';
    const msg2 = 'Warning: These project are not audited and are provided "as is" without any warranties. Use at your own risk. The developers of the project are not liable for any inaccuracies or errors in the information provided. Exercise caution and do your own research before using the project. Source code of the project is open source and can be verified on the blockchain explorer. By using the project, you acknowledge and agree that code is law, the developers take no responsibility and cannot be held liable for any claims, liabilities, hacks, expenses or damages.';
    const nextPage = async () => {
      const disclaimerHide = this.state.disclaimerHide;
      const val = disclaimerHide ? 'yes' : 'no';
      await Lib.setStorageValue('DISCLAIMER_HIDE', val);

      this.setState({ show: 'content' });
    };

    return (
      <View style={{ padding: 15 * vp, backgroundColor: 'black', flex: 1, alignItems: 'flex-start', justifyContent: 'center' }}>
        <Text style={{ color: 'white', fontWeight: 'bold' }}>Alpha Testing</Text>
        <Text style={{ color: 'white' }}>{msg1}</Text>
        <Text> </Text>
        <Text> </Text>
        <Text style={{ color: 'white', fontWeight: 'bold' }}>Disclaimer</Text>
        <Text style={{ color: 'white' }}>{msg2}</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <CheckBox color="gray" style={{}} value={this.state.disclaimerAgree} onValueChange={ok => this.setState({ disclaimerAgree: ok })} />
          <Text style={{ color: 'white' }}> I understand & agree</Text>
        </View>
        <Text> </Text>
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <CheckBox color="gray" style={{}} value={this.state.disclaimerHide} onValueChange={ok => this.setState({ disclaimerHide: ok })} />
          <Text style={{ color: 'white' }}> Dont show this page again</Text>
        </View>
        <Text> </Text>
        <Button disabled={!(this.state.disclaimerAgree)} style={{}} buttonStyle={buttonStyle} titleStyle={titleStyle}
          type='outline' title="Continue" onPress={() => nextPage()} />
        <Text> </Text>
        <Text> </Text>
      </View>
    );
  }

  renderModalMint() {
    const msg1 = 'Minting NFT required 1000 CFX to be staked. Burning NFT will unstake and return 1000 CFX.';
    const msg2 = 'Burn NFT allowed 13 days after minting. Unstake CFX allowed 1 day after burning. Continue to mint?';
    return (
      <Modal
        isVisible={this.state.modalMintVisible}
        onBackdropPress={() => this.setState({ modalMintVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 2 * vp, width: 300 }}>
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
              <Text> </Text>
              <Text style={{ textAlign: 'center' }}>{msg1} {msg2}</Text>
              <Text> </Text>
            </View>
            <View style={{ flexDirection: 'column' }}>
              <View style={{ flex: 1 }}>
                <Button type="outline" title='YES' onPress={() => this.nftMint()} />
              </View>
              <View style={{ width: vp, height: vp }} />
              <View style={{ flex: 1 }}>
                <Button type="outline" title='NO' onPress={() => this.setState({ modalMintVisible: false })} />
              </View>
            </View>
          </View>
        </View>
      </Modal>
    );
  }

  renderModalTx() {
    let indicator = <ActivityIndicator color='gray' size='large' />;
    let msg = 'PROCESSING TX';
    let btnClose = <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalTxVisible: false })} />;
    if (this.state.txHash) {
      msg = 'PROCESS TX DONE';
      const txHash = this.state.txHash;
      indicator = <Button type="outline" title='OPEN ON EXPLORER' onPress={() => Lib.openUrl(evmLib.EURL + '/tx/' + txHash)} />
    } else if (this.state.txError) {
      msg = 'PROCESS TX FAIL';
      indicator = <Text style={{ textAlign: 'center', color: 'red' }}>{this.state.txError}</Text>
    } else {
      btnClose = null;
    }

    return (
      <Modal
        isVisible={this.state.modalTxVisible}
        onBackdropPress={() => this.setState({ modalTxVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 2 * vp, width: 300 }}>
            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
              <Text> </Text>
              <Text style={{ textAlign: 'center' }}>{msg}</Text>
              <Text> </Text>
            </View>
            <View>
              {indicator}
              <View style={{ height: vp }} />
              {btnClose}
            </View>
          </View>
        </View>
      </Modal>
    );
  }

  renderAdmin() {
    if (!this.state.connected) return null;
    const userData = this.state.userData;
    const buyerData = this.state.buyerData;
    const nftData = this.state.nftData;
    const enableBuy = buyerData.mayBuy;

    const enableUpdate = buyerData.mayUpdate;
    const nextTime = moment.unix(this.state.nftData.nextUpdateTime);
    let msg = 'Update enable on ' + nextTime.format('DD MMM HH:mm:ss') + '.';
    if (enableUpdate) {
      msg = 'Update enabled.';
    }

    let msgArbitrage = 'Run simulation first.';
    let enableArbitrage = false;
    if (this.state.simulationResult) {
      const strategy = this.state.simulationResult.strategy;
      if (strategy === 'pump' || strategy === 'dump') enableArbitrage = true;
      if (!enableArbitrage) msgArbitrage = 'No need to synchronize.';
      else msgArbitrage = 'Need to synchronize.';
    }

    const nftId = this.state.selectedNFT;
    const totalNFT = nftData.totalNFT;
    const revenue = nftData.revenue;

    const btnApprove = (
      <View>
        <Button disabled={!(buyerData.userUSDTAllowance === '0')} style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} type='outline'
          title='Approve' onPress={() => this.buyerApproveUSDT()} />
        <View style={{ height: vp }} />
      </View>
    )

    const btnBurnAll = (
      <View>
        <Button disabled={!(Number(userData.userToken) > 0)} style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} type='outline'
          title='Burn All' onPress={() => this.burnAllToken()} />
        <View style={{ height: vp, textAlign: 'center' }} />
      </View>
    )

    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 5 * vp }}>
        <Text style={textStyle1}>Revenue: {revenue}</Text>
        <Text style={textStyle1}>Supply NFT: {totalNFT}</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          {btnBurnAll}
          <View style={{ width: vp }} />
          {btnApprove}
        </View>
        <Text> </Text>
        <Text style={textStyle1}>{msgArbitrage}</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <Button style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} disabled={false} type='outline' title='Simulate' onPress={() => this.simulateArbitrage(nftId)} />
          <View style={{ width: vp }} />
          <Button style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} disabled={!enableArbitrage} type='outline' title='Synchronize' onPress={() => this.runArbitrage(nftId)} />
        </View>
        <Text> </Text>
        <Text> </Text>
        <Text style={textStyle1}>{msg}</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <Button style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} disabled={!enableUpdate} type='outline' title='Update' onPress={() => this.buyerUpdate()} />
          <View style={{ width: vp }} />
          <Button style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle} disabled={!enableBuy} type='outline' title='Buy & Burn' onPress={() => this.buyerBuy()} />
        </View>
        <Text> </Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <Button style={{ width: 150 }} buttonStyle={buttonStyle} titleStyle={titleStyle}
            disabled={false} type='outline' title='Admin Action' onPress={() => this.adminAction()} />
        </View>
      </View>
    );
  }

  renderDisconnect() {
    const networkName = 'Conflux eSpace';
    const chainlistURL = 'https://chainlist.org/chain/1030';

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'black' }}>
        <View style={{ padding: vp }}>
          <Button type='outline' buttonStyle={buttonStyle} titleStyle={titleStyle} title='Install Metamask' onPress={() => Lib.openUrl('https://metamask.io')} />
          <View style={{ height: vp }} />
          <Button type='outline' buttonStyle={buttonStyle} titleStyle={titleStyle} title={'Switch network to ' + networkName} onPress={() => Lib.openUrl(chainlistURL)} />
          <View style={{ height: vp }} />
          <Button type='outline' buttonStyle={buttonStyle} titleStyle={titleStyle} title='Refresh page' onPress={() => window.location.reload()} />
        </View>
      </View>
    );
  }

  renderPricePanel() {
    if (!this.state.connected) return null;
    const nftData = this.state.nftData;
    const treasuryData = this.state.treasuryData;
    const sellPrice = treasuryData.sellPrice;
    const swapSellPrice = treasuryData.swapSellPrice;

    let memberStatus = 'NOT CULT MEMBER';
    if (nftData.userOwnedNFTIds.length > 0) {
      memberStatus = 'CULT MEMBER #' + this.state.selectedNFT;
    }

    const urlTrade = 'https://app.swappi.io/#/swap?inputCurrency=CFX&outputCurrency=0x2eB3a860Ddd8BC2B2621aA99168D414C14802c9f';
    const urlAnalyze = 'https://dexscreener.com/conflux/0x87a340a3abb0c20ea047ff4c1a55b3356f850788';

    return (
      <View style={{ flex: 1 }}>
        <Text style={textStyle1}>XYZ Price</Text>
        <Text style={textStyle1b}>${swapSellPrice}</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <Button buttonStyle={buttonStyle} titleStyle={titleStyle} style={{ width: 150 }} type='outline' title='Trade' onPress={() => Lib.openUrl(urlTrade)} />
          <View style={{ width: vp }} />
          <Button buttonStyle={buttonStyle} titleStyle={titleStyle} style={{ width: 150 }} type='outline' title='Chart' onPress={() => Lib.openUrl(urlAnalyze)} />
        </View>
        <Text> </Text>
        <Text> </Text>
      </View>
    );
  }

  renderUserPanel() {
    if (!this.state.connected) return null;
    const userData = this.state.userData;
    const nftData = this.state.nftData;
    const walletAddress = userData.userAddress;
    let balanceToken = userData.userToken;
    let balanceETH = userData.userETH;
    let balanceUSDT = userData.userUSDT;

    let memberStatus = 'NOT CULT MEMBER';
    if (nftData.userOwnedNFTIds.length > 0) {
      memberStatus = 'CULT MEMBER #' + this.state.selectedNFT;
    }

    const walletContent = balanceToken + ' ' + TOKEN + ' | ' + balanceETH + ' ' + ETH + ' | ' + balanceUSDT + ' ' + USDT;

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: 2 * vp }}>
        <Text> </Text>
        <Text style={textStyle1}>{memberStatus}</Text>
        <Text style={textStyle1}>{walletAddress}</Text>
        <Text style={textStyle1}>{walletContent}</Text>
        <Text> </Text>
      </View>
    );
  }

  renderDebug() {
    if (!this.state.connected) return null;
    const userData = this.state.userData;
    const buyerData = this.state.buyerData;
    const nftData = this.state.nftData;
    const treasuryData = this.state.treasuryData;
    return (
      <View style={{ flex: 1, padding: vp }}>
        <Text>{JSON.stringify(userData, null, 1)}</Text>
        <Text>{JSON.stringify(buyerData, null, 1)}</Text>
        <Text>{JSON.stringify(nftData, null, 1)}</Text>
        <Text>{JSON.stringify(treasuryData, null, 1)}</Text>
      </View>
    );
  }

  renderPanel(title, desc, btnTitle, cb, disable, iconName) {
    if (!iconName) iconName = 'question';
    return (
      <View style={{ flex: 1, borderWidth: 1, borderColor: 'gainsboro', padding: vp * 2, backgroundColor: 'white' }}>
        <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{title.toUpperCase()}</Text>
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <Text> </Text>
          <Icon name={iconName} size={64} color="black" />
          <Text> </Text>
          <Text style={{ textAlign: 'center' }}>
            {desc}
          </Text>
          <Text> </Text>
        </View>
        <Button disabled={disable} title={btnTitle} onPress={() => cb()} />
      </View>
    );
  }

  renderPanelSwap(swapType) {
    const userData = this.state.userData;
    const treasuryData = this.state.treasuryData;
    const userTokenAllowance = treasuryData.userTokenAllowanceOK; // treasuryData.userTokenAllowance && treasuryData.userTokenAllowance !== '0';
    const userUSDTAllowance = treasuryData.userUSDTAllowanceOK; // treasuryData.userUSDTAllowance && treasuryData.userUSDTAllowance !== '0';
    const enableArbitrage = treasuryData.enableArbitrage;
    let needApprove = true;
    let resultSwap = this.state.resultSwap ? this.state.resultSwap : '0';
    let token1;
    let token2;
    let approveFunc;
    let swapFunc;
    let ownedAmount;

    if (swapType === 'buy') {
      if (userUSDTAllowance) needApprove = false;
      approveFunc = () => this.approveUSDT();
      swapFunc = () => this.swapCoinToToken(this.state.amountInput, this.state.selectedNFT);
      token1 = 'USDT';
      token2 = 'XYZ';
      ownedAmount = userData.userUSDT;
    }
    else if (swapType === 'sell') {
      if (userTokenAllowance) needApprove = false;
      approveFunc = () => this.approveToken();
      swapFunc = () => this.swapTokenToCoin(this.state.amountInput, this.state.selectedNFT);
      token1 = 'XYZ';
      token2 = 'USDT';
      ownedAmount = userData.userToken;
    }

    const s1 = { textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' };

    let enableSwap = false;
    if (this.state.selectedNFT && this.state.selectedNFT > 0) {
      if (!needApprove && Number(this.state.amountInput) > 0 && Number(ownedAmount) > 0) {
        enableSwap = true;
      }
    }

    let ps = { width: vps(96), borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };
    if (landscape) ps = { borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: vps(2) }}>
        <View style={ps}>
          <Text> </Text>
          <Text style={s1}>Swap {token1} to {token2}</Text>
          <Text> </Text>
          <Text> </Text>
          <Text>Owned {ownedAmount} {token1}</Text>
          <Text> </Text>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 1 }}>
              <TextInput
                value={this.state.amountInput}
                onChangeText={txt => this.setAmountInput(txt, swapType)}
                keyboardType='numeric'
                placeholder={'Enter ' + token1}
                style={{ borderWidth: 1, padding: 5, flex: 1 }}
              />
            </View>
            <View style={{ width: vp }} />
            <View style={{ flexDirection: 'row' }}>
              <View style={{ flex: 1 }}>
                <Button style={{ flex: 1 }} type='outline' title='50%' onPress={
                  () => this.setAmountByPctg(50, swapType)
                } />
              </View>
              <View style={{ width: vp }} />
              <View style={{ flex: 1 }}>
                <Button style={{ flex: 1 }} type='outline' title='100%' onPress={
                  () => this.setAmountByPctg(100, swapType)
                } />
              </View>
            </View>
          </View>
          <Text> </Text>
          <Text>Receive {resultSwap} {token2}</Text>
          <Text> </Text>
          <Button disabled={!needApprove} title={'Approve ' + token1} onPress={
            () => approveFunc()} />
          <View style={{ height: vp }} />
          <Button disabled={!enableSwap} title={'Swap ' + token1} onPress={
            () => swapFunc()} />
          <View style={{ height: vp }} />
          <Button disabled={false} type='outline' title='Back' onPress={
            () => this.setState({ show: 'content' })} />
        </View>
      </View>
    );
  }

  renderStake() {
    const getLPUrl = 'https://app.swappi.io/#/add/v2/0xfe97E85d13ABD9c1c33384E796F10B73905637cE/0x2eB3a860Ddd8BC2B2621aA99168D414C14802c9f';
    const treasuryData = this.state.treasuryData;
    const nftData = this.state.nftData;

    const s1 = { textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 24 };
    const s2 = { textAlign: 'center', textTransform: 'uppercase' };

    const lpd = this.state.lpvaultData;
    let msgInterest;
    if (lpd.userDailyInterestInToken > 0) {
      const txt2 = '($' + to4dec(lpd.userDailyInterestInUSDT) + ')';
      msgInterest = '7D Avg. Daily Reward ' + to2dec(lpd.userDailyInterestInToken) + ' XYZ ' + txt2;
    } else {
      msgInterest = '7D Avg. Daily Reward ' + to2dec(lpd.dailyInterest) + ' XYZ/LP';
    }

    const apy = Math.floor(lpd.apy);
    const apr = Math.floor(lpd.apr);
    const ownedLP = lpd.balanceLPTokenUser;
    const stakedLP = lpd.userStake;
    const reward = lpd.userUnclaimedReward;

    let msgReward = 'Reward ' + reward + ' XYZ';
    let titleBtnUnstake = 'Unstake';
    let unstakeTimeWarning;

    if (Number(reward) > 0) {
    }

    else if (!lpd.mayUnstake && lpd.userAllowUnstakeTime > 0) {
      // titleBtnUnstake = 'Enable ' + moment.unix(lpd.userAllowUnstakeTime).format('DD MMM HH:mm');
      const txt = 'Unstake enable ' + moment.unix(lpd.userAllowUnstakeTime).format('DD MMM HH:mm');
      unstakeTimeWarning = <Text>{txt}</Text>
    }
    let titleBtnClaim = 'Claim Reward';
    if (lpd.userTurn > 0 && lpd.userTurn >= lpd.vaultTurn) {
      msgReward = 'Next reward ' + moment.unix(nftData.nextUpdateTime).format('DD MMM HH:mm');
      // titleBtnClaim = 'Enable ' + moment.unix(nftData.nextUpdateTime).format('DD MMM HH:mm');
    }

    let cultAccess = true; // (this.state.selectedNFT && this.state.selectedNFT > 0);

    const inputOK = Number(this.state.amountInputLP) > 0;

    const enableUnstake = lpd.mayUnstake && inputOK && cultAccess;
    const enableStake = lpd.mayStake && inputOK && cultAccess;
    const enableClaim = lpd.mayClaim && cultAccess && !(nftData.freezeTime);

    let btnApprove = null;
    if (lpd.approved) {
    } else {
      btnApprove = (
        <View>
          <Button disabled={!cultAccess} title='Approve XYZ-USDT LP' onPress={
            () => this.lpvaultApprove()} />
          <View style={{ height: vp }} />
        </View>
      );
    }

    let btnClaimReward = (
      <Button disabled={!enableClaim} title={titleBtnClaim} onPress={
        () => this.lpvaultClaim()} />
    );

    const withdrawAmount = lpd.userPendingWithdraw;
    const withdrawTime = moment.unix(lpd.userAllowWithdrawTime).format('DD MMM HH:ss');
    const mayWithdraw = lpd.mayWithdraw && cultAccess;
    const userStakedInUSDT = lpd.userStakedInUSDT ? '($' + lpd.userStakedInUSDT + ')' : '';

    if (Number(withdrawAmount) > 0) {
      let enableWithdraw = false;
      msgReward = 'Unstaking ' + withdrawAmount + ' XYZ-USDT LP.\nWithdraw enable after ' + withdrawTime;
      if (mayWithdraw) {
        enableWithdraw = true;
        msgReward = '' + withdrawAmount + ' XYZ-USDT LP unstaked.';
      }
      btnClaimReward = <Button disabled={!enableWithdraw} title={'Withdraw'} onPress={() => this.lpvaultWithdraw()} />
    }

    let ps = { width: vps(96), borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };
    if (landscape) ps = { borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: vps(2) }}>
        <View style={ps}>
          <Text> </Text>
          <Text style={s2}>Stake XYZ-USDT LP</Text>
          <Text style={s1}>{apr}% APR</Text>
          <Text style={s2}>{msgInterest}</Text>
          <Text> </Text>
          <Text> </Text>
          <Text> </Text>
          <Text>Owned {ownedLP} XYZ-USDT LP</Text>
          <Text> </Text>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 1 }}>
              <TextInput
                value={this.state.amountInputLP}
                onChangeText={txt => this.setState({ amountInputLP: txt })}
                keyboardType='numeric'
                placeholder={'Amount stake/unstake'}
                style={{ borderWidth: 1, padding: 5, flex: 1 }}
              />
            </View>
            <View style={{ width: vp }} />
            <View style={{ flexDirection: 'row' }}>
              <Button style={{ flex: 1 }} type='outline' title='Get LP' onPress={
                () => Lib.openUrl(getLPUrl)
              } />
            </View>
          </View>
          <Text> </Text>
          <Text>Staked {to2dec(stakedLP)} XYZ-USDT LP {userStakedInUSDT}</Text>
          {unstakeTimeWarning}
          <Text> </Text>
          {btnApprove}
          <View style={{ flexDirection: 'row' }}>
            <Button style={{}} type='outline' title='100%' onPress={
              () => this.setState({ amountInputLP: ownedLP })
            } />
            <View style={{ width: vp }} />
            <View style={{ flex: 1 }}>
              <Button disabled={!enableStake} title='Stake' onPress={
                () => this.lpvaultStake(this.state.amountInputLP)} />
            </View>
          </View>
          <View style={{ height: vp }} />
          <View style={{ flexDirection: 'row' }}>
            <Button style={{}} type='outline' title='100%' onPress={
              () => this.setState({ amountInputLP: stakedLP })
            } />
            <View style={{ width: vp }} />
            <View style={{ flex: 1 }}>
              <Button disabled={!enableUnstake} title={titleBtnUnstake} onPress={
                () => this.lpvaultUnstake(this.state.amountInputLP)} />
            </View>
          </View>
          <Text> </Text>
          <Text>{msgReward}</Text>
          <Text> </Text>
          {btnClaimReward}
          <View style={{ height: vp }} />
          <Button disabled={false} type='outline' title='Back' onPress={
            () => this.setState({ show: 'content' })} />
        </View>
      </View>
    );
  }

  renderBonding() {
    const swapType = 'buy';
    const userData = this.state.userData;
    const treasuryData = this.state.treasuryData;
    const userTokenAllowance = treasuryData.userTokenAllowance && treasuryData.userTokenAllowance !== '0';
    const userUSDTAllowance = treasuryData.userUSDTAllowance && treasuryData.userUSDTAllowance !== '0';
    const enableArbitrage = treasuryData.enableArbitrage;
    let needApprove = true;
    let resultSwap = this.state.resultSwap ? Number(this.state.resultSwap) : 0;
    let resultSwapFromDex = this.state.resultSwapFromDex ? Number(this.state.resultSwapFromDex) : 0;
    let bonusAmount = 0;
    let bonusPctg = 0;
    let receiveAmount = resultSwap;
    let totalAmount = resultSwap;

    if (resultSwap > resultSwapFromDex) {
      receiveAmount = resultSwapFromDex;
      totalAmount = resultSwap;
      bonusAmount = (resultSwap - resultSwapFromDex);
      bonusPctg = Math.floor((bonusAmount * 100) / resultSwapFromDex);
    }

    let token1;
    let token2;
    let approveFunc;
    let swapFunc;
    let ownedAmount;

    if (userUSDTAllowance) needApprove = false;
    approveFunc = () => this.approveUSDT();
    swapFunc = () => this.swapCoinToToken(this.state.amountInput, this.state.selectedNFT);
    token1 = 'USDT';
    token2 = 'XYZ';
    ownedAmount = userData.userUSDT;

    const s1 = { textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 24 };

    let enableSwap = false;
    // if (this.state.selectedNFT && this.state.selectedNFT > 0) {
    //   if (!needApprove && Number(this.state.amountInput) > 0 && Number(ownedAmount) > 0) {
    //     enableSwap = true;
    //   }
    // }
    if (!needApprove && Number(this.state.amountInput) > 0 && Number(ownedAmount) > 0) {
      enableSwap = true;
    }

    let ps = { width: vps(96), borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };
    if (landscape) ps = { borderWidth: 1, borderColor: 'gainsboro', backgroundColor: 'white', padding: vps(2) };

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: vps(2) }}>
        <View style={ps}>
          <Text> </Text>
          <Text style={s1}>Bonding</Text>
          <Text style={{ textAlign: 'center' }}>Swap USDT for more XYZ than Swappi</Text>
          <Text style={{ textAlign: 'center' }}>Enter more USDT for more bonus!</Text>
          <Text> </Text>
          <Text> </Text>
          <Text>Owned {ownedAmount} USDT</Text>
          <Text> </Text>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 1 }}>
              <TextInput
                value={this.state.amountInput}
                onChangeText={txt => this.setAmountInput(txt, swapType)}
                keyboardType='numeric'
                placeholder={'Enter ' + token1}
                style={{ borderWidth: 1, padding: 5, flex: 1 }}
              />
            </View>
            <View style={{ width: vp }} />
            <View style={{ flexDirection: 'row' }}>
              <View style={{ flex: 1 }}>
                <Button style={{ flex: 1 }} type='outline' title='50%' onPress={
                  () => this.setAmountByPctg(50, swapType)
                } />
              </View>
              <View style={{ width: vp }} />
              <View style={{ flex: 1 }}>
                <Button style={{ flex: 1 }} type='outline' title='100%' onPress={
                  () => this.setAmountByPctg(100, swapType)
                } />
              </View>
            </View>
          </View>
          <Text> </Text>
          <Text>Receive {receiveAmount} XYZ</Text>
          <Text>Bonus {bonusAmount} XYZ (+{bonusPctg}%)</Text>
          <Text>Total {totalAmount} XYZ</Text>
          <Text> </Text>
          <Button disabled={!needApprove} title={'Approve ' + token1} onPress={
            () => approveFunc()} />
          <View style={{ height: vp }} />
          <Button disabled={!enableSwap} title={'Swap ' + token1} onPress={
            () => swapFunc()} />
          <View style={{ height: vp }} />
          <Button disabled={false} type='outline' title='Back' onPress={
            () => this.setState({ show: 'content' })} />
        </View>
      </View>
    );
  }

  renderContent() {
    // return <DAO selectedNFT={this.state.selectedNFT} userData={this.state.userData} lpvaultData={this.state.lpvaultData} treasuryData={this.state.treasuryData} nftData={this.state.nftData} />;
    if (this.state.show === 'disclaimer') {
      return (
        <ScrollView style={{ flex: 1, backgroundColor: 'black' }}>
          <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <View style={{ maxWidth: vps(100) }}>
              {this.renderDisclaimer()}
            </View>
          </View>
        </ScrollView>
      );
    }

    const busyView = (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'black' }}>
        <ActivityIndicator color='white' size='large' />
      </View>
    );

    let show = this.state.show;
    // show = 'content'; // hack

    const contentIndex = this.state.contentIndex;
    const selectedNFT = this.state.selectedNFT;
    const userData = this.state.userData;
    const treasuryData = this.state.treasuryData;
    const lpvaultData = this.state.lpvaultData;
    const nftData = this.state.nftData;

    if (show === 'connecting') return busyView;
    else if (show === 'disconnect') return this.renderDisconnect();

    let middleContent = (
      <View />
    );

    if (show === 'content') {
      const panelsData = {
        ts: userData.blocktime,
        userETH: userData.userETH,
        selectedNFT,
        apr: lpvaultData.apr,
        bonus: treasuryData.bonus,
        bonusSampleAmount: treasuryData.bonusSample,
        sellPrice: treasuryData.sellPrice,
        rewardPerNFT: to4dec(nftData.rewardPerNFT),
        nextUpdateTime: nftData.nextUpdateTime,
        nftDataList: nftData.dataList,
        nftSession: nftData.session,
        nftPendingWithdraw: nftData.pendingWithdraw,
        nftPendingWithdrawDeadline: nftData.pendingWithdrawDeadline,
        nftMayWithdraw: nftData.mayWithdraw,
      };

      middleContent = (
        <View style={{}}>
          <Panels
            panelsData={panelsData}
            onClickStake={() => this.setState({ show: 'stake', amountInputLP: '' })}
            onClickSwap={() => this.setState({ show: 'swapBuy', amountInput: '' })}
            onClickSell={() => this.setState({ show: 'swapSell', amountInput: '' })}
            onClickClaim={() => this.nftClaim(selectedNFT)}
            onClickJoin={() => this.setState({ modalMintVisible: true })}
            onClickLeave={() => this.burnNFT(selectedNFT)}
            onClickWithdraw={() => this.nftWithdraw(nftData.pendingWithdrawIndex)}
            userData={this.state.userData} lpvaultData={this.state.lpvaultData} treasuryData={this.state.treasuryData} nftData={this.state.nftData} />
        </View>
      );
    }

    if (show === 'swapBuy') {
      middleContent = (
        <View style={{}}>
          {this.renderBonding()}
        </View>
      );
    }

    if (show === 'swapSell') {
      middleContent = (
        <View style={{}}>
          {this.renderPanelSwap('sell')}
        </View>
      );
    }

    if (show === 'stake') {
      middleContent = (
        <View style={{}}>
          {this.renderStake()}
        </View>
      );
    }

    if (contentIndex === 1) {
      middleContent = (
        <View style={{}}>
          <Analytic lpvaultData={this.state.lpvaultData} treasuryData={this.state.treasuryData} nftData={this.state.nftData} />
        </View>
      );
    } else if (contentIndex === 2) {
      middleContent = (
        <View style={{}}>
          <DAO selectedNFT={this.state.selectedNFT} userData={this.state.userData} lpvaultData={this.state.lpvaultData} treasuryData={this.state.treasuryData} nftData={this.state.nftData} />
        </View>
      );
    }

    let adminPanel;
    if (userData && (userData.isAdmin)) {
      adminPanel = (<View>
        <Text> </Text>
        {this.renderAdmin()}
        <Text> </Text>
      </View>);
    }

    const imgUrl = '/logo192.png';
    const imgSz = 20 * vp;

    const col2 = '#eeeeee';
    const menuCols = [col2, col2, col2];
    const textCols = ['black', 'black', 'black'];
    const cI = this.state.contentIndex ? this.state.contentIndex : 0;
    menuCols[cI] = 'black';
    textCols[cI] = 'white';

    return (
      <ScrollView style={{ flex: 1 }}>
        <View style={{ alignItems: 'center', backgroundColor: 'black' }}>
          <View style={{ maxWidth: vps(100), padding: vps(2), alignItems: 'center' }}>
            <Text> </Text>
            <Image
              style={{ width: imgSz, height: imgSz }}
              source={{ uri: imgUrl }}
            />
            <Text> </Text>
            {this.renderPricePanel()}
            <Text> </Text>
          </View>
        </View>
        <View style={{ alignItems: 'center', backgroundColor: 'gainsboro', paddingVertical: landscape ? vps(2) : 0 }}>
          <View style={{
            width: vps(100), flexDirection: 'row', borderColor: 'gainsboro',
            paddingHorizontal: 0, borderBottomWidth: 0, borderTopWidth: 1
          }}>
            <TouchableOpacity onPress={() => this.setState({ contentIndex: 0 })}
              style={{ flex: 1, backgroundColor: menuCols[0], padding: vps(2), alignItems: 'center', justifyContent: 'center' }}>
              <Icon name='home' size={32} color={textCols[0]} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => this.setState({ contentIndex: 1 })}
              style={{ flex: 1, backgroundColor: menuCols[1], padding: vps(2), alignItems: 'center', justifyContent: 'center' }}>
              <Icon name='search-plus' size={32} color={textCols[1]} />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => this.setState({ contentIndex: 2 })}
              style={{ flex: 1, backgroundColor: menuCols[2], padding: vps(2), alignItems: 'center', justifyContent: 'center' }}>
              <Icon name='user' size={32} color={textCols[2]} />
            </TouchableOpacity>
          </View>
          <View style={{ width: vps(100), paddingHorizontal: 0 }}>
            {middleContent}
          </View>
        </View>
        <View style={{ alignItems: 'center', backgroundColor: 'black' }}>
          <View style={{ maxWidth: vps(100), padding: vps(2) }}>
            {this.renderUserPanel()}
            {adminPanel}
          </View>
        </View>
      </ScrollView >
    );
  }

  renderFooter() {
    if (this.state.connected) {
      return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ textAlign: 'center' }}>CONNECTED TO CONFLUX ESPACE</Text>
        </View>
      );
    }

    if (this.state.connecting) {
      return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ textAlign: 'center' }}>CONNECTING TO CONFLUX ESPACE</Text>
        </View>
      );
    }

    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Text style={{ textAlign: 'center' }}>DISCONNECTED TO CONFLUX ESPACE</Text>
      </View>
    );
  }

  renderHeader() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Text style={{ textAlign: 'center' }}>DRAGONCULT v0.23 - ALPHA TESTING PHASE</Text>
      </View>
    );
  }

  render() {
    const contentLayout = this.state.contentLayout;
    if (!contentLayout) {
      return (
        <View style={{ flex: 1 }}>
          <View style={{}}>
            <Text> </Text>
            <Text> </Text>
            <Text> </Text>
          </View>
          <View style={{ flex: 1 }} onLayout={e => {
            const contentLayout = e.nativeEvent.layout;
            this.setState({ contentLayout });
          }}>
            <ActivityIndicator color='gray' size='large' />
          </View>
          <View style={{}}>
            <Text> </Text>
            <Text> </Text>
            <Text> </Text>
          </View>
        </View>
      );
    }

    return (
      <View style={{ flex: 1 }}>
        {this.renderModalTx()}
        {this.renderModalMint()}
        <View style={{ flex: 1, borderBottomColor: 'gainsboro', borderBottomWidth: 1 }}>
          {this.renderHeader()}
        </View>
        <View style={{ width: contentLayout.width, height: contentLayout.height }} >
          {this.renderContent()}
        </View>
        <View style={{ flex: 1, borderTopColor: 'gainsboro', borderTopWidth: 1 }}>
          {this.renderFooter()}
        </View>
      </View>
    );

  }

}

export default Home;
